/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DGA Control API
 * Sistema de monitoreo de extracción de aguas según Resolución 1238 de la DGA (Dirección General de Aguas).
 *
 * ## Protocol-level errors
 *
 * Answered to a request that is no operation of this spec, so no operation declares them. Their `type` is in `ProblemTypeEnum`.
 *
 * - `405` `/problems/method-not-allowed`: the HTTP verb is not supported on that path.
 * - `404` `/problems/not-found`: the URL matched no route at all. Distinct from an endpoint own 404, which means the route exists and the record does not.
 * OpenAPI spec version: 2.0.0
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  ConfigurationListResponseV3,
  ConfigurationRetrieveResponseV3,
  ConfigurationsV3ConfigsPartialUpdatePathParameters,
  ConfigurationsV3ConfigsRetrievePathParameters,
  PatchedConfigurationPatchRequestV3Request
} from '../types';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';



interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};







@Injectable({ providedIn: 'root' })
export class ConfigurationsConfigurationService {
  private readonly http = inject(HttpClient);
/**
 * Returns every key registered in `KNOWN_CONFIG_KEYS` with its metadata (`key_type`, `description`, `default_value`) and current DB value. Lazy-creates a row per key on first call so every entry has an `identity` for the front to PATCH by (M-api-2).
 * @summary List all registered Configuration KV keys (admin-only)
 */
 configurationsV3ConfigsList<TData = ConfigurationListResponseV3>( options?: HttpClientBodyOptions): Observable<TData>;
 configurationsV3ConfigsList<TData = ConfigurationListResponseV3>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 configurationsV3ConfigsList<TData = ConfigurationListResponseV3>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  configurationsV3ConfigsList<TData = ConfigurationListResponseV3>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v3/configurations/configs/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v3/configurations/configs/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/v3/configurations/configs/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Resolves the row by `identity` (M-api-2). Returns 404 if the identity does not exist. Returns 500 `/problems/configuration-key-unknown` if the row is an orphan (its `key` was removed from `KNOWN_CONFIG_KEYS` but the DB row persists).
 * @summary Retrieve one Configuration KV row by identity (admin-only)
 */
 configurationsV3ConfigsRetrieve<TData = ConfigurationRetrieveResponseV3>(pathParams: ConfigurationsV3ConfigsRetrievePathParameters, options?: HttpClientBodyOptions): Observable<TData>;
 configurationsV3ConfigsRetrieve<TData = ConfigurationRetrieveResponseV3>(pathParams: ConfigurationsV3ConfigsRetrievePathParameters, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 configurationsV3ConfigsRetrieve<TData = ConfigurationRetrieveResponseV3>(pathParams: ConfigurationsV3ConfigsRetrievePathParameters, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  configurationsV3ConfigsRetrieve<TData = ConfigurationRetrieveResponseV3>(
    { identity }: ConfigurationsV3ConfigsRetrievePathParameters, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/v3/configurations/configs/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/v3/configurations/configs/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/v3/configurations/configs/${identity}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Type-validates the incoming `value` against the row's `key_type` (dispatched by `TYPE_VALIDATORS`). Returns 422 `/problems/configuration-key-type-mismatch` on cast failure. 500 `/problems/configuration-type-unsupported` if the registry declared a `key_type` without a matching validator (fail closed), and 500 `/problems/configuration-key-unknown` for an orphan row.
 * @summary Update one Configuration KV value by identity (admin-only)
 */
 configurationsV3ConfigsPartialUpdate<TData = ConfigurationRetrieveResponseV3>(pathParams: ConfigurationsV3ConfigsPartialUpdatePathParameters,
    patchedConfigurationPatchRequestV3Request?: PatchedConfigurationPatchRequestV3Request, options?: HttpClientBodyOptions): Observable<TData>;
 configurationsV3ConfigsPartialUpdate<TData = ConfigurationRetrieveResponseV3>(pathParams: ConfigurationsV3ConfigsPartialUpdatePathParameters,
    patchedConfigurationPatchRequestV3Request?: PatchedConfigurationPatchRequestV3Request, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 configurationsV3ConfigsPartialUpdate<TData = ConfigurationRetrieveResponseV3>(pathParams: ConfigurationsV3ConfigsPartialUpdatePathParameters,
    patchedConfigurationPatchRequestV3Request?: PatchedConfigurationPatchRequestV3Request, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  configurationsV3ConfigsPartialUpdate<TData = ConfigurationRetrieveResponseV3>(
    { identity }: ConfigurationsV3ConfigsPartialUpdatePathParameters,
    patchedConfigurationPatchRequestV3Request?: PatchedConfigurationPatchRequestV3Request, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/v3/configurations/configs/${identity}/`,
      patchedConfigurationPatchRequestV3Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/v3/configurations/configs/${identity}/`,
      patchedConfigurationPatchRequestV3Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.patch<TData>(
      `/v3/configurations/configs/${identity}/`,
      patchedConfigurationPatchRequestV3Request,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};

export type ConfigurationsV3ConfigsListClientResult = NonNullable<ConfigurationListResponseV3>
export type ConfigurationsV3ConfigsRetrieveClientResult = NonNullable<ConfigurationRetrieveResponseV3>
export type ConfigurationsV3ConfigsPartialUpdateClientResult = NonNullable<ConfigurationRetrieveResponseV3>
